const titles: {
  [key: string]: string;
} = {
  register: 'アカウント作成 | donut robotics',
  mypage: 'マイページ | donut robotics',
};

export default titles;
